import {toPost} from "../../http-utils";

export const messageDestroy = toPost<
    {
        id:number
    },
    { }
    >("/merchant/live/messageDestroy")